import React from 'react';
import BasicRadioButton from './BasicRadioButton';


export interface IRadioImageButton {
    id: number, 
    text: string, 
    isChecked: boolean, 
    onClick: any, 
    className?: string,
    imageSrc: string,
    imageAlt?: string,
    isNew?: boolean,
}

const RadioImageButton= ({id, text, isChecked, onClick, className, isNew, imageSrc, imageAlt} : IRadioImageButton) => {   
    return (
        <span 
            key={`radio-image-button-${id}`} 
            className={
                `radio-image-button 
                ${className ? className :  ""} 
                ${isChecked ? "selected-radio-image-button" : "not-selected-radio-image-button"}`
            }
        >
            <img
                src={imageSrc}
                alt={imageAlt}
                className='radio-image'
                onClick={onClick}
            />

            <span className="basic-image-radio-button-container">
                <BasicRadioButton 
                    className='basic-image-radio-button'
                    id={id} 
                    text={text} 
                    isChecked={isChecked} 
                    onClick={onClick}
                />

                {isNew &&
                    <span className='new-display-icon'>
                        New 
                    </span>
                }
            </span>
        </span>
    );
}
  
export default RadioImageButton